import React from "react";
import { Link, graphql, useStaticQuery  } from "gatsby";
import { getSrc } from "gatsby-plugin-image";
export default function Footer() {
  return (
    <div>
      <footer>
      <div className="flow-root bg-slate-200">
            <ul className="text-gray-500 inline-flex pt-2">
              <li className="mb-2 px-2">
                © 2023 Owners Accommodations, All Rights Reserved
              </li>
            </ul>
            <ul className="text-gray-500 inline-flex pt-2 sm:float-right">
              
              <li className="mb-2 px-2">
                <Link to="/terms_and_conditions" className="hover:underline text-gray-400">
                  Terms of Use
                </Link>
              </li>
              <li className="mb-2 px-2">
                <Link to="/privacy_policy" className="hover:underline text-gray-400">
                  Privacy Policy
                </Link>
              </li>
             
            </ul>
        </div>
        </footer>
    </div>
  );
}
